var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"userRef",staticClass:"pop-box"},[_c('keep-alive',[_c(_vm.currentComponent,{ref:"userRight",tag:"component",on:{"changeView":_vm.changeView,"hideView":_vm.hidePop}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }